import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap, reduce } from 'rxjs/operators';

type TAppName = 'oi-app' | 'plani8' | 'ui' | 'ba-app' | 'input-app' | 'mm' | 'organizi8' | 'engineeri8';

const COMMON_TRANSLATION_SOURCES = ['./assets/ui-i18n/'];

const SOURCES: Record<TAppName, string[]> = {
  ui: [...COMMON_TRANSLATION_SOURCES],
  'oi-app': [...COMMON_TRANSLATION_SOURCES, './assets/i18n/'],
  plani8: [...COMMON_TRANSLATION_SOURCES],
  'ba-app': [...COMMON_TRANSLATION_SOURCES, './assets/i18n/'],
  'input-app': [...COMMON_TRANSLATION_SOURCES, './assets/i18n/'],
  mm: [...COMMON_TRANSLATION_SOURCES, './assets/i18n/common/', './assets/i18n/mobile/', './assets/i18n/web/'],
  organizi8: [...COMMON_TRANSLATION_SOURCES, './assets/i18n/'],
  engineeri8: [...COMMON_TRANSLATION_SOURCES, './assets/i18n/'],
};

export class TranslationLoaderService implements TranslateLoader {
  constructor(private http: HttpClient, private appName: TAppName) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    return from(SOURCES[this.appName]).pipe(
      mergeMap((source) => {
        const url = `${source}${lang}.json`;
        return this.http.get(url).pipe(
          catchError((error) => {
            console.log(`[ERROR]: Could not load translation files. ${url}`, error);
            return of({});
          }),
        );
      }),
      reduce(
        (mergedTranslations, translations) => ({
          ...mergedTranslations,
          ...translations,
        }),
        {},
      ),
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderFactory {
  constructor(private http: HttpClient) {}

  createForApp(appName: TAppName): TranslationLoaderService {
    return new TranslationLoaderService(this.http, appName);
  }
}
